import { useEffect, useState } from 'react';
import { IWhoHasFocus } from '../interfaces';

const defaultFocus = { doesAnyone: true, index: -1 };
const noFocus = { doesAnyone: false, index: -1 };

export type IFocusTrackState = [IWhoHasFocus, (x: IWhoHasFocus) => void];

export const useFocusTrackingState = (): IFocusTrackState => {
  const [whoHasFocus, setWhoHasFocus] = useState(defaultFocus);
  useEffect(() => {
    setWhoHasFocus(noFocus);
  }, [whoHasFocus]);
  return [whoHasFocus, setWhoHasFocus];
};
